export const GeneralResourceSearchTypes = {
  GENERAL_RESOURCE_SEARCH: 'GENERAL_RESOURCE_SEARCH',
  GENERAL_RESOURCE_LAST_SEARCH: 'GENERAL_RESOURCE_LAST_SEARCH',
};
